import { render, staticRenderFns } from "./referral-info-list-status.vue?vue&type=template&id=bbc2cf28&scoped=true"
import script from "./referral-info-list-status.vue?vue&type=script&lang=js"
export * from "./referral-info-list-status.vue?vue&type=script&lang=js"
import style0 from "./referral-info-list-status.vue?vue&type=style&index=0&id=bbc2cf28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc2cf28",
  null
  
)

export default component.exports